<template>
    <div class="placeOrder warp">
      <div class="poAddressBox">
        <div class="poTitle">请选择收货地址</div>
        <div class="noAddress" v-if="addressData.length === 0" @click="newAddressFn">
          <div class="noAddressBox">
            <span class="iconfont">&#xe6d4;</span>
            <span>新增收货地址</span>
          </div>
        </div>
        <div class="poAddressList" v-if="addressData.length !== 0">
          <div class="poAddListTit">
            <span>收件人信息</span>
            <span @click="newAddressFn">新增地址</span>
          </div>
          <div class="poAddListBox">
            <div class="showMoreBox" :class="{showMoreAdd: showMoreAddress}">
              <div class="addressItem" :class="{addressActive: curAdd === index}" @click="selectAddress(item, index)" v-for="(item, index) of addressData" :key="item.receiveId">
                <span class="userName">{{item.receiveName}}<i v-if="curAdd === index" class="iconfont">&#xe612;</i></span>
                <span class="addressInfo">{{item.receiveAdress}} {{item.address}}</span>
                <span class="phone">{{item.receivePhone}}</span>
              </div>
            </div>
            <div class="openMore iconfont" @click="openMoreAdd" v-html="showMoreAddress ? '收起地址&#xe660;' : '展开更多&#xe695;'"></div>
          </div>
        </div>
        <div class="poTitle">请确认订单信息</div>
        <div class="orderList">
          <div class="orderInfoTit">
            <span>店铺商品</span>
            <span>商品属性</span>
            <span>单价</span>
            <span>数量</span>
           <span>优惠方式</span>
            <span>小计</span>
          </div>
        </div>
        <shop-order ref="shopOrder" :type="state" :shopsData="shopsData"></shop-order>
      </div>
      <div class="remarksBox">
        <div class="remarksInfo">
          <el-input
            type="textarea"
            :rows="2"
            resize="none"
            placeholder="如有其他要求，请备注。"
            v-model="remarksInfo">
          </el-input>
        </div>
      </div>
      <div class="couponBox">
        <div class="couponTitle" v-if="settlementData.coupons.length !== 0"><span>使用优惠券<i class="iconfont" v-html="'&#xe695;'"></i></span></div>
        <div class="discountList clearfix">
          <!-- <div @click="preferentialUse(item, index)" class="couponItem" :class="{active: currentCoupon === index}" v-for="(item, index) of settlementData.coupons" :key="item.couponId"> -->
          <div @click="preferentialUse(item, index)" class="couponItem" :class="{active: curPrefCouponInx === index}" v-for="(item, index) of settlementData.coupons" :key="item.couponId">
            <div class="couponItemTop">
              <img src="../../assets/images/indexLogo.png" alt="">
              <span><i>￥</i>{{item.reduceMoney}}</span>
              <span style="height:15px;">使用条件：{{item.content}}</span>
              <span>有效期至：{{item.endTime}}</span>
              <div class="couponType">平台卷</div>
            </div>
            <div class="couponItemBot">
              立即使用
              <span class="iconfont currentSelect" v-if="curPrefCouponInx === index">&#xe612;</span>
            </div>
          </div>
          <div v-for="(item, index) of shopsData" :key="item.shopId">
            <!-- <div @click="selectShopCoupon(shop, shopIndex)" class="couponItem" :class="{active: currentShopCoupon === shopIndex}" v-for="(shop, shopIndex) of item.shopCoupons" :key="shop.id"> -->
            <div @click="selectShopCoupon(item, index, shop)" class="couponItem" :class="{active: shopCoupons[index].id === shop.id}" v-for="(shop) of item.shopCoupons" :key="shop.id">
              <div class="couponItemTop">
                <img src="../../assets/images/indexLogo.png" alt="">
                <!--                <span><i>￥</i>{{item.reduceMoney}}</span>-->
                <span>优惠：{{shop.content}}</span>
                <span style="height:15px;"></span>
                <span>有效期至：{{shop.endTime}}</span>
                <div class="couponType">店铺券</div>
              </div>
              <div class="couponItemBot">
                立即使用
                <!-- <span class="iconfont currentSelect" v-if="currentShopCoupon === shopIndex">&#xe612;</span> -->
                <span class="iconfont currentSelect" v-if="shopCoupons[index].id === shop.id">&#xe612;</span>
              </div>
            </div>
          </div>
        </div>
        <div class="couponList">
          <div class="payTit">选择支付方式</div>
          <div class="payList">
<!--            <span :class="{payActive: payType === 'alipay'}" @click="selectPay(type = 'alipay')">-->
<!--              <i class="iconfont">&#xe627;</i>-->
<!--              <b class="iconfont">&#xe612;</b>-->
<!--              支付宝支付-->
<!--            </span>-->
            <span :class="{payActive: payType === 'weChat'}" @click="selectPay(type = 'weChat')">
              <i class="iconfont">&#xe686;</i>
              <b class="iconfont">&#xe612;</b>
              微信支付
            </span>
          </div>
        </div>
      </div>
      <div class="placeOrderBtn">
        <!-- <span>商品优惠：-￥{{(prefAmount + shopDiscountAmount).toFixed(2)}}</span> -->
        <span>运费：+¥{{distributionPrice.toFixed(2)}}</span>
        <span>商品优惠：-￥{{(prefDis + shopCouponDis).toFixed(2)}}</span>
        <span>需付款：<b>￥{{orderDisTotal.toFixed(2)}}</b></span>
        <el-button @click="clickPayOrder" type="primary" v-throttle>提交订单</el-button>
      </div>
      <el-dialog
        title="请在1小时内完成付款，否则订单会被系统取消"
        :visible.sync="paymentDialog"
        width="30%">
        <div class="payment">
          <div class="paymentBox">
            <div class="successBox">
              <span>支付成功请点击</span>
              <el-button type="primary" plain>已完成付款</el-button>
            </div>
            <div class="errorBox">
              <span>遇到问题请点击</span>
              <el-button type="primary" v-throttle>重新付款</el-button>
            </div>
          </div>
          <div class="paymentInfo">
            <p>注：重新付款前，请关闭之前的付款页面</p>
            <p>如有疑问或需要帮助，请进入<b>帮助中心</b>或联系<b>在线客服</b></p>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        class="weChat"
        :title="`请使用微信扫一扫支付￥${payInfo.money}`"
        :visible.sync="weChatDialog"
        :before-close="handleClose"
        width="30%">
        <div class="weChatBox">
          <div class="qCode">
            <img :src="payInfo.url" alt="">
            <img src="../../assets/images/weiXintit.png" alt="">
          </div>
          <div class="weChatInfo">
            <img src="../../assets/images/imgPay.png" alt="">
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="新建收货地址"
        :visible.sync="newAddressDialog"
        width="630px">
        <add-address @hideAddDialog="hideAddDialog" @cancelAdd="closeAdd"></add-address>
      </el-dialog>
      <el-dialog
        title="错误！"
        :visible.sync="errorDialog"
        width="30%">
        <div class="errorDialog">
          <div class="errorTit">
            <span class="iconfont">&#xe620;</span>
            <p>您的订单支付失败</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" v-throttle>查看订单</el-button>
            <el-button type="primary" @click="dialogVisible = false" v-throttle>重新支付</el-button>
          </span>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import addAddress from '../../components/orderInfo/addAddress'
import shopOrder from '../../components/orderInfo/shopOrder'
import couponList from '../../components/orderInfo/coupon'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'placeOrder',
  mixins: [listSearchMixin],
  components: {
    addAddress,
    shopOrder,
    couponList
  },
  data () {
    return {
      addressData: [],
      showMoreAddress: false,
      newAddressDialog: false,
      paymentDialog: false,
      weChatDialog: false,
      payType: '',
      errorDialog: false,
      curAdd: 0,
      settlementData: {
        coupons: []
      },
      shopsData: [],
      showDiscount: false,
      currentCoupon: null,
      currentShopCoupon: null,
      prefAmount: 0,
      shopDiscountAmount: 0,
      currentDiscount: 0,
      discountTotal: 0, // 优惠总额
      orderTotal: 0,
      couponCurrent: {},
      shopCouponCurrent: {},
      submitData: {
        receiveId: '',
        couponId: '',
        price: '',
        remark: '',
        shops: []
      },
      currentAddressId: '',
      remarksInfo: '',
      payInfo: {},
      chatTimer: '',
      activityType: null,
      workData: {},
      shopData: [],
      type: null,
      ifWork: null,
      discount: 0,
      shopCouponDis: 0, // 使用店铺券后的优惠额度
      prefDis: 0, // 使用平台券后的优惠额度
      curPrefCoupon: null, // 当前平台券
      curShopCoupon: null, // 当前店铺券
      curPrefCouponInx: null, // 当前平台券的索引
      curShopCouponId: null, // 当前店铺券的id
      orderDisTotal: 0, // 减去优惠后的付款价格
      state: 0,
      shopCoupons: [],
      distributionPrice: 0 // 总运费
    }
  },
  created () {
    if (this.$route.query.works) {
      this.workData = JSON.parse(this.$route.query.works)
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.$route.query.ifWork !== undefined) {
      this.ifWork = this.$route.query.ifWork
    }
    this.activityType = this.$route.query.activityType
    if (this.$route.query.shops) {
      this.shopData = JSON.parse(this.$route.query.shops)
    }
    if (this.shopData.shopDiscountId) {
      this.state = 3
    }
    if (this.shopData.shopSeckillId) {
      this.state = 2
    }
    if (this.workData.shopGroupWorkId) {
      this.state = 1
    }
  },
  mounted () {
    // 获取地址列表
    this.getAddressList()
    if (this.$route.query.type) {
      this.getSetProList()
    } else {
      this.getWorkSettlement()
    }
  },
  computed: {
    ...mapGetters([
      'newAddress' // 新增修改收货地址
    ])
  },
  methods: {
    ...mapMutations({
      seNewAddress: 'SET_NEWADDRESS', // 新增修改收货地址
      setAreacode: 'SET_AREACODE', // 新增修改收货地址
      setCartNumber: 'SET_CARTNUMBER', // 购物车数量
      setShoppingCart: 'SET_SHOPPINGCART' // 购物车
    }),
    // 获取地址列表
    getAddressList () {
      let self = this
      let params = {
        url: api.addressList,
        method: 'GET',
        payload: {
          page: 1,
          pageSize: 100
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.addressData = res.data.list
        } else {
          self.$message.warning(res.message)
        }
      })
    },
    // 新增地址
    hideAddDialog () {
      this.newAddressDialog = false
      let self = this
      let params = {
        url: api.newAddress,
        method: 'POST',
        data: {
          receiveName: self.newAddress.receiveName,
          receivePhone: self.newAddress.receivePhone,
          receiveAdress: self.newAddress.receiveAdress,
          address: self.newAddress.address,
          label: '',
          defult: self.newAddress.defult.toString()
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.$message({
            message: '地址添加成功',
            type: 'success'
          })
          self.page = 1
          self.addressData = []
          self.setAreacode([])
          self.getAddressList()
        } else {
          self.$message.error(res.message)
        }
      })
    },
    // 取消新增地址
    closeAdd () {
      this.newAddressDialog = false
    },
    selectAddress (item, index) {
      this.curAdd = index
      this.currentAddressId = item.receiveId
      if (this.$route.query.type) {
        this.getSetProList()
      } else {
        this.getWorkSettlement()
      }
    },
    // 新增地址
    newAddressFn () {
      let obj = {
        receiveName: '',
        receivePhone: '',
        receiveAdress: '',
        address: '',
        label: '',
        defult: 'false'
      }
      this.setAreacode([])
      this.seNewAddress(obj)
      this.newAddressDialog = true
    },
    // 展开更多地址
    openMoreAdd () {
      this.showMoreAddress = !this.showMoreAddress
    },
    // 拼团商品结算查询
    getWorkSettlement () {
      const rLoading = this.openLoading()
      let self = this
      self.orderDisTotal = 0
      self.distributionPrice = 0
      self.orderTotal = 0
      let params = {
        url: api.getWorkSettlement,
        method: 'POST',
        data: this.workData
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.settlementData = res.data
          self.currentAddressId = res.data.receive.receiveId || ''
          self.shopsData = res.data.shops
          for (let key in self.shopsData) {
            self.orderTotal = self.orderTotal + self.shopsData[key].total
            self.shopCoupons.push({id: null, ifAdd: null, reduceMoney: null})
          }
          self.shopsData.forEach(i => {
            this.distributionPrice += Number(i.distribution.distributionPrice)
          })
          self.orderDisTotal = Number(self.orderTotal) + this.distributionPrice
          rLoading.close()
        } else {
          self.$message.warning(res.message)
        }
      })
    },
    // 查询结算产品列表
    getSetProList () {
      const rLoading = this.openLoading()
      let self = this
      self.orderDisTotal = 0
      self.distributionPrice = 0
      self.orderTotal = 0
      // console.log(self.shopData)
      let params = {
        url: api.getSettlement,
        method: 'POST',
        data: {
          type: this.type,
          shops: this.shopData,
          ifWork: this.ifWork,
          receiveId: this.currentAddressId
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.settlementData = res.data
          self.currentAddressId = res.data.receive.receiveId || ''
          self.shopsData = res.data.shops
          for (let key in self.shopsData) {
            self.orderTotal = self.orderTotal + self.shopsData[key].total
            self.shopCoupons.push({id: null, ifAdd: null, reduceMoney: null})
          }
          self.shopsData.forEach(i => {
            this.distributionPrice += Number(i.distribution.distributionPrice)
          })
          self.orderDisTotal = Number(self.orderTotal) + this.distributionPrice
          rLoading.close()
        } else {
          self.$message.warning(res.message)
          self.$router.back()
        }
      })
    },
    // preferentialUse (item, index) {
    //   if (this.currentCoupon === index) {
    //     this.prefAmount = 0
    //     this.couponCurrent = {}
    //     this.currentCoupon = null
    //   } else {
    //     if (this.shopCouponCurrent.ifAdd === 0) {
    //       this.currentDiscount = 0
    //       this.shopCouponCurrent = {}
    //       this.currentShopCoupon = null
    //     }
    //     this.couponCurrent = item
    //     this.prefAmount = item.reduceMoney
    //     this.currentCoupon = index
    //   }
    // },
    // 选择平台券
    preferentialUse (item, index) {
      if (item.reduceMoney >= this.orderTotal) {
        return this.$message.warning('优惠券金额不能大于付款金额')
      }
      let flag = true
      this.shopCoupons.forEach(i => {
        if (i.id && i.ifAdd === 0) {
          flag = false
        }
      })
      if (flag) {
        if (this.curPrefCouponInx === index) {
          this.prefDis = 0
          this.curPrefCoupon = null
          this.curPrefCouponInx = null
        } else {
          this.prefDis = Number(item.reduceMoney)
          this.curPrefCoupon = item
          this.curPrefCouponInx = index
        }
      } else {
        this.$message.warning('已选择的店铺券中存在不能叠加的')
      }
    },
    // selectShopCoupon (item, index) {
    //   if (this.currentShopCoupon === index) {
    //     this.currentDiscount = 0
    //     this.shopCouponCurrent = {}
    //     this.currentShopCoupon = null
    //   } else {
    //     if (item.ifAdd === 0) {
    //       this.prefAmount = 0
    //       this.couponCurrent = {}
    //       this.currentCoupon = null
    //     }
    //     this.orderTotal = this.orderTotal + this.shopDiscountAmount
    //     this.shopDiscountAmount = 0
    //     this.shopCouponCurrent = item
    //     if (item.reduceMoney < 10) {
    //       this.currentDiscount = item.reduceMoney * 0.1
    //     } else {
    //       this.currentDiscount = item.reduceMoney * 0.01
    //     }
    //     this.currentShopCoupon = index
    //   }
    // },
    // 选择店铺券
    selectShopCoupon (item, index, shop) {
      if (shop.couponType === 1) {
        if (shop.reduceMoney >= this.orderDisTotal) {
          return this.$message.warning('优惠券金额不能大于付款金额')
        }
      }
      if (shop.ifAdd === 1 || (this.curPrefCoupon === null && shop.ifAdd === 0)) {
        if (this.shopCoupons[index].id === shop.id) {
          this.curShopCoupon = null
          this.shopCoupons[index].id = null
          this.shopCoupons[index].ifAdd = null
          this.shopCoupons[index].reduceMoney = null
        } else {
          if (item.ids) {
            if (shop.couponType === 1) {
              let disMoney = 0
              shop.ids.map(i => {
                item.skus.map(j => {
                  if (i === j.productId) {
                    disMoney += j.total
                  }
                })
              })
              if (disMoney - shop.reduceMoney > 0) {
                this.shopCoupons[index].reduceMoney = Number(shop.reduceMoney)
              } else {
                this.shopCoupons[index].reduceMoney = Number(disMoney)
              }
              this.shopCoupons[index].id = shop.id
              this.shopCoupons[index].ifAdd = shop.ifAdd
              this.shopCoupons[index].reduceMoney = shop.reduceMoney
              this.curShopCoupo = shop
            } else {
              let disMoney = 0
              shop.ids.map(k => {
                item.skus.map(l => {
                  if (k === l.productId) {
                    disMoney += l.total
                  }
                })
              })
              this.shopCoupons[index].id = shop.id
              this.shopCoupons[index].ifAdd = shop.ifAdd
              this.shopCoupons[index].reduceMoney = shop.reduceMoney
              this.curShopCoupon = shop
              this.shopCoupons[index].reduceMoney = Number(disMoney * (1 - shop.reduceMoney * 0.1))
            }
          } else {
            if (shop.couponType === 1) {
              if (item.total - shop.reduceMoney > 0) {
                this.shopCoupons[index].reduceMoney = Number(shop.reduceMoney)
              } else {
                this.shopCoupons[index].reduceMoney = Number(item.total)
              }
              this.shopCoupons[index].id = shop.id
              this.shopCoupons[index].ifAdd = shop.ifAdd
              this.shopCoupons[index].reduceMoney = shop.reduceMoney
              this.curShopCoupon = shop
            } else {
              this.shopCoupons[index].id = shop.id
              this.shopCoupons[index].ifAdd = shop.ifAdd
              this.shopCoupons[index].reduceMoney = shop.reduceMoney
              this.curShopCoupon = shop
              this.shopCoupons[index].reduceMoney = Number(item.total * (1 - shop.reduceMoney * 0.1))
            }
          }
        }
      } else {
        this.$message.warning('此店铺券不能叠加平台券')
        // this.prefDis = 0
        // this.curPrefCoupon = null
        // this.curPrefCouponInx = null
        // if (this.shopCoupons[index].id === shop.id) {
        //   this.shopCouponDis = 0
        //   this.curShopCoupon = null
        //   this.shopCoupons[index].id = null
        //   this.shopCoupons[index].ifAdd = null
        // } else {
        //   if (item.ids) {
        //     if (shop.couponType === 1) {
        //       let disMoney = 0
        //       shop.ids.map(i => {
        //         item.skus.map(j => {
        //           if (i === j.productId) {
        //             disMoney += j.total
        //           }
        //         })
        //       })
        //       if (disMoney - shop.reduceMoney > 0) {
        //         this.shopCouponDis = Number(shop.reduceMoney)
        //       } else {
        //         this.shopCouponDis = Number(disMoney)
        //       }
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupo = shop
        //       // this.shopCouponDis = Number(shop.reduceMoney)
        //     } else {
        //       let disMoney = 0
        //       shop.ids.map(k => {
        //         item.skus.map(l => {
        //           if (k === l.productId) {
        //             disMoney += l.total
        //           }
        //         })
        //       })
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupon = shop
        //       this.shopCouponDis = Number(disMoney * (1 - shop.reduceMoney * 0.1))
        //     }
        //   } else {
        //     if (shop.couponType === 1) {
        //       if (item.total - shop.reduceMoney > 0) {
        //         this.shopCouponDis = Number(shop.reduceMoney)
        //       } else {
        //         this.shopCouponDis = Number(item.total)
        //       }
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupon = shop
        //       // this.shopCouponDis = Number(shop.reduceMoney)
        //     } else {
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupon = shop
        //       this.shopCouponDis = Number(item.total * (1 - shop.reduceMoney * 0.1))
        //     }
        //   }
        // }
      }
    },
    // 选择支付方式
    selectPay (type) {
      this.payType = type
    },
    // 提交支付
    clickPayOrder () {
      if (this.payType === '') {
        this.$message.warning('请选择支付方式')
      } else if (this.currentAddressId === '') {
        this.$message.warning('请选择您的收货地址')
      } else {
        let shops = []
        this.shopsData.forEach((j, i) => {
          let skus = []
          j.skus.forEach((k, n) => {
            if (k.selected) {
              skus.push({
                skuId: k.skuId,
                number: k.number,
                selected: k.selected
              })
            }
          })
          if (skus.length) {
            shops.push({
              shopId: j.shopId,
              id: this.shopCoupons[i].id || '',
              distribution: {
                distributionPrice: j.distribution.distributionPrice,
                logisticsId: j.distribution.logisticsId
              },
              skus
            })
          }
        })
        this.submitData.couponId = this.curPrefCoupon ? this.curPrefCoupon.couponId : ''
        // this.submitData.id = this.curShopCoupon ? this.curShopCoupon.id : ''
        this.submitData.receiveId = this.currentAddressId
        this.submitData.price = parseFloat(this.orderDisTotal.toFixed(2))
        // this.submitData.discountPrice = this.prefAmount + this.shopDiscountAmount
        this.submitData.discountPrice = parseFloat((this.prefDis + this.shopCouponDis).toFixed(2))
        this.submitData.remark = this.remarksInfo
        this.submitData.shops = shops
        if (this.activityType === '1' && this.ifWork !== '1') {
          this.submitData.shopGroupWorkId = this.workData.shopGroupWorkId
          this.submitData.type = 1
          if (this.workData.collageId) {
            this.submitData.collageId = this.workData.collageId
            this.submitData.type = 2
          }
        } else if (this.activityType === '2') {
          this.submitData.shopSeckillId = this.shopData[0].shopSeckillId
          this.submitData.type = 3
        } else if (this.activityType === '3') {
          this.submitData.shopDiscountId = this.shopData[0].shopDiscountId
          this.submitData.type = 4
        }
        console.log(this.shopData)
        console.log(this.submitData)
        this.orderSubmit(this.submitData, 'submitData')
      }
    },
    // 提交订单
    orderSubmit (subData) {
      let self = this
      let params = {
        url: api.orderSubmit,
        method: 'POST',
        data: subData
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          // self.pay(res.data)
          self.payInfo = res.data
          self.getTrolleyList()
          // console.log(res.data, '提交返回')
          self.weChatDialog = true
          self.chatTimer = setInterval(() => {
            self.checkPay(res.data)
          }, 3000)
        } else {
          self.$message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    },
    // 模拟支付
    pay (data) {
      let params = {
        url: api.pay,
        method: 'PUT',
        data: {
          money: data.money,
          orderId: data.orderId,
          type: 1
        }
      }
      this.sendReq(params, (res) => {
        if (res.code === '200') {
          this.$router.push({path: '/myOrder'})
        }
      })
    },
    // 查询订单是否支付成功
    checkPay (paramsData) {
      setTimeout(() => {
        let self = this
        let params = {
          url: api.checkPay + `?collageId=${paramsData.collageId}&money=${paramsData.money}&orderId=${paramsData.orderId}&type=1`,
          method: 'GET'
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            if (res.data.code === 'SUCCESS') {
              self.$message({
                message: '支付成功！',
                type: 'success'
              })
              clearInterval(self.chatTimer)
              self.getTrolleyList()
              self.$router.push({path: '/myOrder'})
            }
          } else {
            clearInterval(self.chatTimer)
            self.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      }, 0)
    },
    // 获取购物车列表
    async getTrolleyList () {
      const vm = this
      const params = {
        url: api.getTrolleyList,
        method: 'GET'
      }
      vm.sendReq(params, res => {
        const d = res.data
        let cartNumber = 0
        // console.log(d)
        if (d.length) {
          d.forEach(j => {
            cartNumber = cartNumber + j.skus.length
          })
        }
        this.setShoppingCart(d)
        this.setCartNumber(cartNumber)
      })
    },
    // 取消支付
    handleClose () {
      this.$confirm('确认取消支付？')
        .then(_ => {
          clearInterval(this.chatTimer)
          this.$router.push({path: '/myOrder'})
        })
        .catch(_ => {})
    }
  },
  // watch: {
  //   prefAmount (val, oldVal) {
  //     if (val === 0) {
  //       this.orderTotal = this.orderTotal + oldVal
  //     } else {
  //       this.orderTotal = this.orderTotal - val
  //     }
  //   },
  //   currentDiscount (val, oldVal) {
  //     if (val === 0) {
  //       this.orderTotal = this.orderTotal + this.shopDiscountAmount
  //       this.shopDiscountAmount = 0
  //     } else {
  //       this.shopDiscountAmount = this.orderTotal - (this.orderTotal * val)
  //       this.orderTotal = this.orderTotal - this.shopDiscountAmount
  //     }
  //   }
  // }
  watch: {
    shopCoupons: {
      handler (newVal, oldVal) {
        this.shopCouponDis = 0
        this.shopCoupons.forEach(i => {
          if (i.id) {
            this.shopCouponDis += i.reduceMoney
          }
        })
        this.orderDisTotal = this.orderTotal + this.distributionPrice - (this.shopCouponDis).toFixed(2) - this.prefDis
        if (this.orderDisTotal <= 0) {
          this.orderDisTotal = 0
        }
      },
      deep: true
    },
    prefDis (newVal, oldVal) {
      this.shopCouponDis = 0
      this.shopCoupons.forEach(i => {
        if (i.id) {
          this.shopCouponDis += i.reduceMoney
        }
      })
      this.orderDisTotal = this.orderTotal + this.distributionPrice - (this.shopCouponDis).toFixed(2) - this.prefDis
      if (this.orderDisTotal <= 0) {
        this.orderDisTotal = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.placeOrder {
  margin: 20px auto;
  .poTitle {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }
  .poAddressList {
    width: 100%;
    border: 1px solid #F5F5F5;
    padding: 20px;
    margin-bottom: 30px;
    box-sizing: border-box;
    .poAddListTit {
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        color: #333333;
        font-size: 16px;
      }
      span:nth-child(2) {
        color: #2D51B3;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .poAddListBox {
      width: 100%;
      margin:20px 50px 0 50px;
      .showMoreBox {
        height: 45px;
        overflow: hidden;
      }
      .showMoreAdd {
        height: auto;
      }
      .addressItem {
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        span {
          color: #666666;
          font-size: 14px;
        }
        span:nth-child(1) {
          width: 147px;
          height: 31px;
          line-height: 31px;
          text-align: center;
          border: 1px solid #CCCCCC;
          border-radius: 2px;
          margin-right: 15px;
          cursor: pointer;
          position: relative;
          i {
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            position: absolute;
            right: -1px;
            bottom: 0;
            color: $mainColor;
          }
        }
        span:nth-child(2) {
          margin-right: 20px;
        }
      }
      .openMore {
        font-size: 12px;
        color: #666666;
        cursor: pointer;
      }
      .currentAddress {
        span:nth-child(1) {
          border-color: $mainColor;
        }
      }
      .addressActive {
        span:nth-child(1) {
          border-color: $mainColor;
        }
      }
      .showMoreAdd {
        height: auto;
      }
    }
  }
  >>> .el-dialog {
    .el-dialog__body {
      background: #F8F8F8;
    }
    .el-dialog__header {
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
      .dialog-footer {
        text-align: center;
        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }
  .poAddressBox {
    .noAddress {
      width: 300px;
      height: 166px;
      display: flex;
      align-items: center;
      text-align: center;
      border: 2px solid #DDDDDD;
      border-radius: 4px;
      margin-top: 40px;
      justify-content: center;
      cursor: pointer;
      margin-bottom: 70px;
      span {
        font-size: 16px;
        color: #666666;
        display: block;
      }
      span:nth-child(1) {
        font-size: 26px;
        margin-bottom: 18px;
      }
    }
  }
  .orderList {
    background: #FCFCFC;
    border: 1px solid #E5E5E5;
    margin-bottom: 25px;
    .orderInfoTit {
      width: 100%;
      display: flex;
      height: 44px;
      line-height: 44px;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
    }
    span {
      text-align: center;
    }
    span:nth-child(1) {
      width: 40%;
      text-align: left;
      padding-left: 125px;
      box-sizing: border-box;
    }
    span:nth-child(2) {
      width: 20%;
      text-align: left;
    }
    span:nth-child(3) {
      width: 15%;
    }
    span:nth-child(4) {
      width: 15%;
    }
    span:nth-child(5) {
      width: 10%;
    }
    span:nth-child(6) {
      width: 10%;
    }
  }
  .couponBox {
    .couponTitle {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #E5E5E5;
      span {
        color: #333333;
        cursor: pointer;
        i {
          margin-left: 5px;
        }
      }
    }
    .discountList {
      margin-top: 30px;
      .couponItem {
        width: 245px;
        border: 1px solid #EEEEEE;
        border-radius: 18px;
        overflow: hidden;
        margin:0 50px 50px 0;
        float: left;
        cursor: pointer;
        // &:nth-child(4n) {
        //   margin-right: 0;
        // }
        .couponItemTop {
          background: #fd5b5b;
          color: #ffffff;
          padding: 20px;
          box-sizing: border-box;
          position: relative;
          img {
            opacity: 0.2;
            position: absolute;
            top: 40%;
          }
          .couponType {
            position: absolute;
            top: 1px;
            right: -33px;
            width: 100px;
            transform: rotate(45deg);
            background: #FFFFFF;
            color: #fd5b5b;
            text-align: center;
            height: 40px;
            line-height: 50px;
          }
          span {
            font-size: 12px;
            display: block;
            margin-bottom: 18px;
            i {
              margin-right: 5px;
              font-style: normal;
              font-size: 16px;
            }
          }
          span:nth-child(2) {
            font-size: 18px;
          }
          span:nth-child(4) {
            margin-bottom: 0;
          }
        }
        .couponItemBot {
          height: 40px;
          line-height: 40px;
          background: #f3f3f3;
          color: #333333;
          position: relative;
          text-align: center;
          cursor: pointer;
          .currentSelect {
            color: $mainColor;
            position: absolute;
            right: -1px;
            bottom: 0;
            font-size: 40px;
          }
        }
      }
      .active {
        border: 1px solid $mainColor;
      }
    }
    .couponList {
      margin-top: 10px;
    }
  }
  .payBox {
    .payTit {
      font-size: 16px;
      color: #333333;
    }
  }
  .placeOrderBtn {
    margin-top: 50px;
    width: 100%;
    background: #F7F7F7;
    padding: 30px;
    box-sizing: border-box;
    text-align: right;
    span {
      display: block;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;
    }
    span:nth-child(3) {
      font-size: 18px;
      b {
        color: $mainColor;
      }
    }
  }
  .payList {
    display: flex;
    margin: 20px 0 0 50px;
    span {
      color: #666666;
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      i {
        font-size: 26px;
        margin-right: 5px;
      }
      b {
        color: $mainColor;
        position: absolute;
        right: -1px;
        bottom: -1px;
        display: none;
      }
    }
    .payActive {
      border: 1px solid $mainColor;
      b {
        display: block;
      }
    }
    span {
      border: 1px solid #E5E5E5;
      padding: 5px 10px;
      margin-right: 15px;
    }
    span:nth-child(1) {
      i:nth-child(1) {
        color: #40ba49;
        cursor: pointer;
      }
    }
    span:nth-child(2) {
      i {
        color:  #40ba49;
      }
    }
  }
  .payment {
    width: 80%;
    margin: 0 auto;
    .paymentBox {
      margin-top: 50px;
      display: flex;
      justify-content: center;
      .successBox, .errorBox {
        width: 240px;
        text-align: center;
      }
      .successBox {
        border-right: 1px solid #DDDDDD;
        >>> .el-button {
          border: 1px solid $mainColor;
        }
      }
      span {
        display: block;
        margin-bottom: 20px;
      }
    }
    .paymentInfo {
      text-align: center;
      margin-top: 60px;
      p {
        font-size: 16px;
        color: #999999;
        line-height: 30px;
        b {
          color: #FF7800;
          cursor: pointer;
          font-weight: normal;
        }
      }
    }
  }
  .weChatBox {
    display: flex;
    img {
      width: 100%;
    }
    .qCode {
      width: 50%;
      text-align: center;
      img {
        width: 80%;
      }
    }
    .weChatInfo {
      width: 50%;
    }
  }
  .weChat {
    >>> .el-dialog__body {
      background: #FFFFFF;
    }
  }
  .errorDialog {
    text-align: center;
    .errorTit {
      span {
        font-size: 50px;
        color: red;
      }
      p {
        margin: 30px 0;
      }
    }
    span {
      display: block;
    }
  }
  .remarksBox {
    display: flex;
    background: #F7F7F7;
    padding: 25px;
    border-radius: 8px;
    margin-bottom: 30px;
    .remarksInfo {
      width: 100%;
      >>> .el-textarea__inner {
        width: 100%;
        height: 84px;
      }
    }
    .selectBox {
      margin-left: 70px;
      label {
        color: #666666;
        font-size: 16px;
        font-weight: normal;
      }
    }
    .shopTotal {
      color: $mainColor;
      flex: 1;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/placeOrder/index.vue